module.exports = __webpack_public_path__ + "static/media/whatsapp.cd8f3f33.svg";